import { NextPage } from 'next';
import ProjectLayout from '@layouts/project-layout/project-layout';
import SocialLukeComponent from '@components/projects/social-luke/social-luke';
import { ProjectProps } from '@models/project.interface';

const SocialLuke: NextPage<ProjectProps> = (project) => {
  return (
    <ProjectLayout project={project}>
      <SocialLukeComponent breadcrumbsText={project.project.breadcrumbsText} />
    </ProjectLayout>
  );
};

export default SocialLuke;
export { getServerSideProps } from '@layouts/project-layout/project-layout';
